/* Hide magnifying glass icon in searchwp input if search input not empty */
// Get references to all search inputs
const searchInputs = document.querySelectorAll(".swp-input--search");

function updateBackgroundImage(input) {
	if (input.value.trim() !== "") {
		input.classList.add("hide-magnifying-glass-icon");
	} else {
		input.classList.remove("hide-magnifying-glass-icon");
	}
}

// Add event listeners to detect input changes for all search inputs
searchInputs.forEach((input) => {
	input.addEventListener("input", () => {
		updateBackgroundImage(input);
	});
});

// Initial call to set the initial state based on input content for all inputs
searchInputs.forEach((input) => {
	updateBackgroundImage(input);
});

/* archive-news page - prevent redirect to search page on submit */
// // Add an event listener to the SearchWP form with ID 'searchwp-form-3'
// document.addEventListener("submit", function (event) {
// 	console.log("SUBMIT - document.addEventListener('submit', function (event) - SUBMIT");

// 	if (event.target.id === "searchwp-form-3") {
// 		const searchInput = event.target.querySelector(".swp-input");
// 		const inputValue = searchInput.value.trim();

// 		// Capture the search data (inputValue)
// 		console.log("Search Query:", inputValue);

// 		// Make an AJAX request to handle the search data
// 		$.ajax({
// 			url: ajax_url, // Use the WordPress AJAX URL
// 			type: "post",
// 			dataType: "json",
// 			data: {
// 				action: "handle_search_data",
// 				search_query: inputValue,
// 			},
// 			success: function (response) {
// 				// Handle the AJAX response as needed
// 				console.log("AJAX Response:", response);
// 			},
// 			error: function (xhr, status, error) {
// 				console.error(xhr.responseText);
// 			},
// 		});

// 		// Prevent the default form submission behavior
// 		event.preventDefault();
// 	}
// });
